import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface OpenClosedSignProps {
  isOpening?: boolean
}

export const OpenClosedSign: FC<OpenClosedSignProps> = ({ isOpening }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const color = isOpening
    ? theme.palette.success.main
    : theme.palette.error.main

  return (
    <Box
      sx={{
        width: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 2,
        paddingX: 2,
        paddingY: 1,
        border: '1px solid',
        borderColor: color,
        color,
      }}
    >
      <Box
        sx={{
          width: 12,
          height: 12,
          borderRadius: 50,
          backgroundColor: color,
          marginRight: 2.5,
        }}
      />
      <Typography variant="h5">
        {isOpening ? t('Opening Now') : t('Closed')}
      </Typography>
    </Box>
  )
}
